<template>
	<div>
		<Top></Top>
		<div class="tab">
			<div class="wd-container">
				<div class="value" :class="tabindex==index ? 'select' : ''"   v-for="(item,index) in classlist" :key="index"  @click="findgoods(index)"><span>{{item.name}}</span></div>
				<!-- <div class="value" :class="activeName == 'hot' ? 'select' : ''"><span>超级爆品</span></div> -->
			</div>
		</div>
		<div class="back">
			<div class="wd-container">
				<div>
					
					<div class="countdown" v-if="startcountdown_s">
						<div class="title">每日必抢</div>
						<div class="value">开始倒计时</div>
						<div class="timer">
							<div class="a">{{sechour}}</div>
							<div class="a">{{secminute}}</div>
							<div class="a b">{{secsecond}}</div>
						</div>
					</div>
					<div class="countdown" v-else>
						<div class="title">每日必抢</div>
						<div class="value">结束倒计时</div>
						<div class="timer">
							<div class="a">{{sechour}}</div>
							<div class="a">{{secminute}}</div>
							<div class="a b">{{secsecond}}</div>
						</div>
					</div>
				</div>
				<div class="goodslist" v-if="wddatalist!=''">
					<div v-for="(item, index) in wddatalist[tabindex].detail" :key="index" class="goodsinfo">
						<div class="info" @click="goodsdetail(index)">
							<div class="img"><el-image fit="contain" :src="$wdpicurl(item.pic1)"></el-image></div>
							<div class="name wd-line-2">{{ item.goodsname }}</div>
						</div>
						<div class="buy">
							<div class="wd-flex wd-row-between detail">
								<div class="price">
									<div>
										<span class="wd-theme">¥</span><span class="wd-font-24 wd-theme">{{item.price1}}</span><span class="wd-m-l-10 wd-font-12 wd-font-delete wd-theme-999">¥{{item.retailprice}}</span>
									</div>
									<div class="progress">
										<el-progress :percentage="parseInt(item.numpercent)" :stroke-width="10"></el-progress>
									</div>
								</div>
								<div class="btn">
									<el-button type="primary"  v-if="parseInt(item.numpercent)<100"  @click="goodsdetail(index)">立即抢购</el-button>
									<el-button type="primary" disabled v-else>已抢完</el-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import Top from '@/components/layout/Top.vue';
import Footer from '@/components/layout/Footer.vue';
export default {
	name: 'Seckill',
	computed: {
		...mapState(['logininfo'])
	},
	components: {
		Top,
		Footer
	},
	data() {
		return {
			activeName: 'miaosha',
			seckillid: '',
			classlist: [],
			tabindex: 0,
			wddatalist: [],
			limit:2000,
			seckillinfo: { id: 0 },
			allseconds: 0,
			allseconds_start:0,
			showmoreclass:false,
			sechour:0,
			secminute:0,
			secsecond:0,
			seckilltimer:null,
			startcountdown_s:false
		};
	},
	methods: {
		handleClick() {
			console.log('handleClick');
		},
		selectitem(index) {
			var item = this.wddatalist[this.tabindex].detail[index];
			item.select = !item.select;
			if (item.select) {
				this.wddatalist[this.tabindex].selectnum++;
			} else {
				this.wddatalist[this.tabindex].selectnum--;
			}
			this.$set(this.wddatalist[this.tabindex].detail, index, item);
		},
		findgoods(index) {
			if (this.tabindex != index && this.wddatalist[index].detail.length > 0) {
				this.tabindex = index;
				return;
			}
			this.tabindex = index;
			var cnt = this.wddatalist[index].cnt || -1;
			var page = this.wddatalist[index].page || 0;
			if (cnt == -1) {
				page = 1;
			} else {
				if (page * this.limit >= cnt) {
					return;
				} else page++;
			}
			this.wddatalist[index].page = page;
			var indata = {
				cnt: cnt,
				page: page,
				seckillid: this.seckillid,
				classid: this.classlist[index].id,
				limit:this.limit
			};
			this.$wd_request('seckill_goodslist', indata,true,".goodslist").then(data => {
				if (cnt == -1) {
					this.wddatalist[index].cnt = data.count;
					this.wddatalist[index].detail = data.value;
				} else {
					this.wddatalist[index].detail = this.wddatalist[index].detail.concat(data.value);
				}
			});
		},
		loadclass() {
			this.$wd_request('appgoodsclass_main', { appflag: 1 }).then(data => {
				this.classlist = data.value;
				this.classlist.unshift({ code: '0', id: '0', name: '全部', select: true });
				for (var i = 0; i < this.classlist.length; i++) {
					this.wddatalist.push({
						cnt: -1,
						page: 0,
						selectnum: 0,
						detail: []
					});
				}
				this.findgoods(0);
			});
		},
		goback() {},
		goodsdetail(index) {
			var item = this.wddatalist[this.tabindex].detail[index];
			if (parseInt(item.numpercent) < 100) {
				var goodsid = item.goodsid;
				var name=item.goodsname;
				this.$router.push({name:"Goodsinfo",query:{goodsid:goodsid,goodsname:name}})
			}
		},
		loadseckillinfo() {
			var indata = {
				limit: 1,
				type: 0
			};
		
			this.$wd_request('seckilllist', indata)
				.then(data => {
					this.seckillinfo = data.value[0];
					if (this.seckillinfo.intdiffs < 0) {
						// this.diffTime(this.seckillinfo.intdiffs*-1,true);
						// this.diffTime(this.seckillinfo.intdiff);
						this.startcountdown_s = true;
						setTimeout(function() {
							this.allseconds_start = 0;
							this.allseconds=this.seckillinfo.intdiff;
							this.startcountdown_s = false;
							this.start_calcseckill(this.seckillinfo.intdiff);
							// that.diffTime(that.seckillinfo.intdiff+that.seckillinfo.intdiffs);
						}, this.seckillinfo.intdiffs * -1000);
					} else {
						this.startcountdown_s = false;
						this.startcountdown = true;
						this.allseconds=this.seckillinfo.intdiff;
						// this.diffTime(this.seckillinfo.intdiff);
						this.start_calcseckill();
					}
					this.loadclass();
				})
				.catch(() => {});
		},
		start_calcseckill(){
			this.clear_calcseckill();
			this.seckilltimer = setInterval(() => {
				this.allseconds--;
				if (this.allseconds < 0) {
					return this.clear_calcseckill();
				}
				this.diffTime(this.allseconds,this.startcountdown_s);
				
			}, 1000);
		},
		clear_calcseckill(){
			clearInterval(this.seckilltimer);
			this.seckilltimer = null;
		},
		diffTime(min) {
			var diff=min*1000;//endDate.getTime() - startDate.getTime();//时间差的毫秒数  
			//计算出相差天数  
			// var days=Math.floor(diff/(24*3600*1000));  
			//计算出小时数  
			var leave1=diff%(24*3600*1000);    //计算天数后剩余的毫秒数  
			var hours=Math.floor(leave1/(3600*1000));  
			//计算相差分钟数  
			var leave2=leave1%(3600*1000);        //计算小时数后剩余的毫秒数  
			var minutes=Math.floor(leave2/(60*1000));  
			//计算相差秒数  
			var leave3=leave2%(60*1000);      //计算分钟数后剩余的毫秒数  
			var seconds=Math.round(leave3/1000);  
			
			hours = hours < 10 ? '0' + hours : hours;
			minutes = minutes < 10 ? '0' + minutes : minutes;
			seconds = seconds < 10 ? '0' + seconds : seconds;
			
			this.sechour=hours;
			this.secminute=minutes;
			this.secsecond=seconds;
			this.startcountdown=true;
		}, 
	},
	created() {
		
		this.loadseckillinfo();
	}
};
</script>

<style lang="scss" scoped>
.back {
	background-color: $wd-theme-back;
	
	.countdown{
		height: 60px;
		line-height: 60px;
		color: #FFFFFF;
		background-color: $wd-theme;
		display: flex;
		justify-content: flex-start;
		flex-shrink: 0;
		margin-bottom: 10px;
		width: 1170px;
		padding-left: 20px;
		.title{
			text-align: center;
			font-size: 30px;
			font-weight: 700;
			width: 150px;
		}
		.value{
			width: 100px;
			text-align: center;
		}
		.timer{
			font-size: 14px;
			text-align: center;
			width: 130px;
			height: 30px;
			display: block;
			margin-top: 15px;
			.a{
				position: relative;
				float: left;
				width: 30px;
				height: 30px;
				line-height: 30px;
				text-align: center;
				background-color: #2f3430;
				margin-right: 20px;
				color: white;
				font-size: 20px;
				&::after{
					content: ":";
					display: block;
					position: absolute;
					right: -20px;
					font-weight: bolder;
					font-size: 18px;
					width: 20px;
					height: 100%;
					top: 0;
				}
				&.b{
					margin-right: 0;
					&::after{
						content: "";
					}
				}
			}
		}
	}
	.goodslist {
		display: flex;
		flex-flow: row wrap;
		flex: none;
		.goodsinfo {
			margin-right: 10px;
			margin-bottom: 10px;
			height: 400px;
			position: relative;
			background-color: #fff;
			display: block;
			&:nth-child(4n){
				margin-right: 0;
			}
			.info {
				width: 250px;
				padding: 20px 20px 0;
				cursor: pointer;
				.img {
					width: auto;
					height: 200px;
					transition: transform 0.3s;
					&:hover {
						transform: translateY(-10px);
					}
					.el-image {
						width: 100%;
						height: 100%;
					}
				}
				.name {
					margin: 20px 0 10px;
				}
			}
			.buy {
				text-align: left;
				height: 100px;
				display: block;
				border-top: 1px solid #f6f6f6;
				position: absolute;
				left:0;
				bottom: 0;
				width: 290px;
				.detail{
					padding:30px 10px 0 20px;
				
					.price {
						width: 160px;
					}
					.btn {
						cursor: pointer;
						// color: #ffffff;
						height: 40px;
						line-height: 40px;
						// font-size: 16px;
						display: block;
						// text-align: center;
						// width: 80px;
						// background-color: #f30213;
						// &:hover {
						// 	background-color: #e03340;
						// }
					}
				}
			}
		}
	}
}
.tab {
	height: 44px;
	width: 100%;
	background: #fff;
	margin-top: 20px;
	border-bottom: 2px solid $wd-theme;
	position: sticky;
	top: 0;
	z-index: 10;
	.value {
		line-height: 44px;
		width: 100px;
		text-align: center;
		float: left;
		font-weight: 700;
		color: #333333;
		cursor: pointer;
		&.select {
			background-color: $wd-theme;
			color: #ffffff;
		}
		&:hover {
			color: $wd-theme;
			&.select {
				color: #ffffff;
			}
		}
	}
}
</style>
